<template>
  <v-select
    outlined
    dense
    hide-details
    v-model="modelValue"
    :items="items"
    :label="label"
    :disabled="disabled"
    :rules="rules"
    :hint="hint"
    :placeholder="placeholder"
    :item-value="itemValue"
    :item-text="itemText"
    :return-object="returnObject"
    :multiple="multiple"
    class="font-size-14"
  />
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash'
export default {
  name: 'SelectComponent',
  props: {
    value: {
      type: [Array, String, Number, Object],
    },
    label: {
      type: String,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
    },
    itemValue: {
      type: String,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    hint: {
      type: String,
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    const initialValue = this.multiple ? [] : null
    const modelValue = isEmpty(this.value) ? initialValue : cloneDeep(this.value)

    return {
      modelValue,
    }
  },
  computed: {},
  watch: {
    modelValue: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped>
.v-select :deep(label) {
  font-size: 14px;
}
</style>
